import { h, Component } from 'preact';
import { observer } from 'mobx-preact';

import util from '../../lib/util';

@observer
class TableCol extends Component {
    render() {
        const { col } = this.props;
        const isNumber = util.isNumber(col);
        const isString = util.isString(col);
        const isComplex = !isNumber && !isString;
        return <td class={`${isNumber ? 'text-right' : ''}`}>
            {isComplex ? <code>{JSON.stringify(col)}</code> : col}
        </td>;
    }
}

@observer
class TableRow extends Component {
    render() {
        const { row } = this.props;

        if (util.isArray(row)) {
            return <tr>
                {row.map(col => <TableCol col={col} />)}
            </tr>;
        }

        return <tr>
            <TableCol col={row} />
        </tr>;
    }
}

@observer
class Array extends Component {
    render() {
        const {
            id,
            name,
            value,
            help,
            readonly,
            required,
            rows,
            placeholder,
            onInput,
            removeHtml,
            handleKeydown,
            isValid,
        } = this.props;
        const isArray = util.isArray(value);

        return (
            <div>
                <textarea class={`form-control ${isValid ? 'is-valid' : ''}`}
                    id={`input${name}-${id}`}
                    name={name}
                    rows={rows}
                    placeholder={placeholder}
                    readonly={readonly}
                    required={required}
                    value={removeHtml ? util.removeHtml(value) : value}
                    onInput={onInput}
                    onKeyDown={handleKeydown}
                />
                <small class='text-muted'>Copy-paste from Excel should work fine. Copy only the column with the articlenos.</small>

                <table class={`table table-striped table-sm table-borderless`}>
                    <tbody>
                        {isArray && value.map(row => <TableRow row={row} />)}
                    </tbody>
                </table>
                <small id={`${name}Help`} class='form-text text-muted'>
                    <small class='float-right text-info ml-2'>"{util.getType(value)}"</small>
                    <small class='float-right'>"{name}"</small>
                    {help}
                </small>
            </div>
        );
    }
}

export default Array;



// WEBPACK FOOTER //
// ./components/form/array.js